/**
 * Client-side notification helper.
 *
 * Fire-and-forget insertion into the notifications table.
 * Mirrors supabase/functions/_shared/notifications.ts for edge functions.
 */

import { supabase } from '@/lib/supabase/client';
import { reportError } from '@/lib/errors';

export type ClientNotificationType =
  | 'message'
  | 'data_room_request'
  | 'data_room_approved'
  | 'profile_view'
  | 'score_update'
  | 'feedback_update'
  | 'waitlist_invited'
  | 'system';

/**
 * Insert a notification row. Fire-and-forget — errors are reported
 * via reportError but never thrown.
 */
export function insertNotification(payload: {
  userId: string;
  type: ClientNotificationType;
  title: string;
  body: string;
  data?: Record<string, unknown>;
}): void {
  supabase
    .from('notifications')
    .insert({
      user_id: payload.userId,
      type: payload.type,
      title: payload.title,
      body: payload.body,
      data: (payload.data ?? {}) as never,
    })
    .then(({ error }) => {
      if (error) reportError(error, { context: 'insertNotification', silent: true });
    });
}
